import debounce from 'lodash/fp/debounce'
import useEventListener from '../useEventListener'

export const useResize = (callback: EventListener) => {
  const debounceCallback = debounce(150)(callback)

  useEventListener('resize', debounceCallback)
  useEventListener('orientationchange', debounceCallback)
}
